import React, { PureComponent } from 'react';

import { openIntercom } from '../globals-service';

import featuredImage from '../images/featured/main.png';
import secondaryImage from '../images/featured/secondary.png';

export default class AuthFlow extends PureComponent {
    state = {
        loaded: false
    }

    handleLearnMoreClick = () => {
        openIntercom();
    }

    handleImageLoaded = () => {
        this.setState({
            loaded: true
        });
    }

    render() {
        return (
            <div className="app-featured">
                <div className="article">
                    <h2><span className="label">Coming Soon</span> Reporting Dashboard</h2>

                    <p>Powerful reporting to keep you on top of your business and workload. Customize your dashboard to gain insights and make informed decisions.</p>
                </div>

                <div className={'image ' + (!this.state.loaded ? ' invisible' : '')}>
                    <img className="main" src={featuredImage} alt="Feature" onLoad={this.handleImageLoaded} />
                    <img className="secondary" style={{display: 'none'}} src={secondaryImage} width="128" height="128" alt="Feature secondary" />
                </div>
            </div>
        );
    }
}
